export default "__VITE_ASSET__CSp2t6Ko__"